import type { BreadcrumbItem, BreadcrumbProps } from './Breadcrumb';

export interface OldBreadcrumbItem extends Omit<BreadcrumbItem, 'leftIcon'> {
  /** @deprecated leftIcon을 대신 사용해주세요. */
  icon?: BreadcrumbItem['leftIcon'];
}

export type OldBreadcrumbProps = Omit<BreadcrumbProps, 'items'> & {
  items: OldBreadcrumbItem[];
};

function convertOldBreadcrumbItem(item: OldBreadcrumbItem): BreadcrumbItem {
  const { icon, ...restItem } = item;

  return {
    ...restItem,
    leftIcon: icon,
  };
}

export function convertOldBreadcrumbProps(props: OldBreadcrumbProps): BreadcrumbProps {
  return {
    ...props,
    items: props.items.map(convertOldBreadcrumbItem),
  };
}
